import { render } from "./FeaturedOnlineType.vue?vue&type=template&id=8168548a&scoped=true&ts=true"
import script from "./FeaturedOnlineType.vue?vue&type=script&lang=ts"
export * from "./FeaturedOnlineType.vue?vue&type=script&lang=ts"

import "./FeaturedOnlineType.vue?vue&type=style&index=0&id=8168548a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8168548a"]])

export default __exports__